// extracted by mini-css-extract-plugin
export default {"pill":"pill_pill__CcrM-","pill--active":"pill_pill--active__boOq1","pill--neutral":"pill_pill--neutral__1A2hM"};